

























































import {
  Component,
  Vue,
  Emit,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import Debounce from "debounce-decorator";

import Loader from "@/components/Loader.vue";
import { formatService } from "../../services/format.service";
import { IProperty } from "../../models/interfaces/property/property.model.interface";
import { IStringPerformanceSummary } from "../../models/interfaces/performance/string-performance-summary.model.interface";
import { IUrlPerformance } from "../../models/interfaces/performance/url-performance.model.interface";

const PropertyPerformanceModule = namespace("propertyPerformanceModule");
const PublisherModule = namespace("publisherModule");
const UserSelectionModule = namespace("userSelectionModule");

@Component({
  components: {
    Loader
  }
})
export default class PropertyUrlPerformanceTable extends Vue {
  @PropertyPerformanceModule.Action public retrievePropertyUrlPerformance;
  @PropertyPerformanceModule.Getter public propertyUrlPerformance;
  @PropertyPerformanceModule.Getter public urlLoadsCount;
  @PropertyPerformanceModule.Getter public urlImpressionCount;
  @PropertyPerformanceModule.Getter public urlClicksCount;
  @UserSelectionModule.Getter public selectedDates;
  @PublisherModule.Getter public selectedProperty: IProperty | null;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: false })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Provide() public urlPath: string = "";

  @Provide() public property: IProperty | null = null;

  @Provide() public items: IStringPerformanceSummary[] = [];

  @Provide()
  public columns = [
    {
      key: "id",
      label: "Url",
      sortable: true
    },
    {
      key: "loads",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumber(value);
      }
    },
    {
      key: "impressions",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.impressions,
          item.loads
        );
      }
    },
    {
      key: "keyPresses",
      label: "Engagements",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.keyPresses,
          item.impressions
        );
      }
    },
    {
      key: "clicks",
      label: "Clicks",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.clicks,
          item.impressions
        );
      }
    }
  ];

  @Provide() public currentPage = 1;
  @Provide() public perPage = 10;
  @Provide() public totalRows = 0;

  private loading: boolean = true;

  get getSelectedProperty(): IProperty | null {
    return this.selectedProperty;
  }

  get getPerformanceData(): IStringPerformanceSummary[] {
    return this.propertyUrlPerformance;
  }

  get getDates(): Date {
    return this.selectedDates;
  }

  @Watch("urlPath")
  public onUrlPathChanged() {
    this.updatePerformanceData();
  }

  @Watch("getSelectedProperty")
  public onSelectedPropertyChanged() {
    this.property = this.getSelectedProperty;
    this.updatePerformanceData();
  }

  @Watch("selectedDates")
  public onDatesChanged() {
    this.updatePerformanceData();
  }

  public getRowCount(items) {
    if (items) {
      return items.length;
    }

    return 0;
  }

  public getRowCountFormatted(items) {
    return formatService.formatNumber(this.getRowCount(items));
  }

  get showPagination(): boolean {
    return this.items.length > this.perPage;
  }

  public getLoadSummary() {
    return formatService.formatNumber(this.urlLoadsCount);
  }

  public getImpressionSummary() {
    return formatService.formatNumberPercentage(
      this.urlImpressionCount,
      this.urlImpressionCount,
      this.urlLoadsCount
    );
  }

  public getClickSummary() {
    return formatService.formatNumberPercentage(
      this.urlClicksCount,
      this.urlClicksCount,
      this.urlImpressionCount
    );
  }

  public hasUrlPath() {
    return this.urlPath && this.urlPath.trim().length > 0;
  }

  @Debounce(1000)
  public updatePerformanceData() {
    this.loading = true;
    if (this.property) {
      const urlModel: IUrlPerformance = {
        propertyId: this.property.propertyId,
        size: this.hasUrlPath() ? 50000 : 100,
        path: this.urlPath
      };

      this.retrievePropertyUrlPerformance(urlModel).then((result) => {
        if (result) {
          this.items = this.getPerformanceData;
        }

        this.loading = false;
      });
    }
  }

  public created() {
    this.property = this.getSelectedProperty;
    this.updatePerformanceData();
  }
}
